module.exports = __webpack_public_path__ + "static/media/2.297bddd0.png";